  <template>
    <v-navigation-drawer
    v-model="show"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    right
    >
        <v-list
        subheader
        flat
        >
        <v-subheader>Search by Name/Address</v-subheader>
            <v-list-item>
                <v-list-item-content class="pa-0">
                    <v-text-field
                        v-model="keyword"
                        light
                        label="Type Name/Address"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        >
 
                    </v-text-field>           
                    <v-btn
                        depressed 
                        tile
                        color="primary"
                        class="mx-0 mb-0 mt-2"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        >
        <v-subheader>Filter by Cleaner</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <div v-for="(item, index) in cleaners" :key="`cleaber-${index}`">
                        <v-checkbox
                            v-model="cleaner"                    
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                            hide-details
                        ></v-checkbox>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        >
        <v-subheader>Filter by Status</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <div v-for="(item, index) in filteredStatuses" :key="`status-${index}`">
                    <v-checkbox
                        v-model="status"
                        color="primary"
                        :value="item.value"
                        :label="item.label"
                        hide-details
                    ></v-checkbox>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['show', 'filter', 'routekey'],
  data: () => ({
    keyword: "",
    menu: false,
    schedule: "",
    status: [],
    dates: [],
    cleaner: [],
  }),
  computed: {
        ...mapGetters({
            statuses: 'data/statusArray',
            cleaners: 'data/cleaners'
        }),
        dateRangeText () {
            if(this.dates.length == 2) {
            if(this.dates[0] > this.dates[1]) {
                return this.dates[1] + '/' + this.dates[0]
            } else {
                return this.dates[0] + '/' + this.dates[1] 
            }
            } else {
                return this.dates[0]
            }
        },
        filteredStatuses() {
            return this.statuses.filter(status => {
                return status.value != 'all' && status.value != 'completed' && status.value != 'cancelled'
            })
        },
  },
  created() {
      this.keyword = this.filter.keyword
      this.status = this.filter.status
      this.cleaner = this.filter.cleaner
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    keyword(newVal) {
        this.$emit('update-keyword', newVal)
    },
    cleaner(newVal) { // watch it
        this.$emit('update-cleaner', newVal)
    },
    status(newVal) { // watch it
        this.$emit('update-status', newVal)
    },
    dateRangeText(newVal) {
        this.$emit('update-daterange', newVal)
    },
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    },
    rangeCancel() {
        this.menu = false
        this.dates = []
    }
  }
}
</script>